/* Royal Fans — wishlist toggle for custom cards. Delegated + guarded so multiple loads are safe. */
(function () {
  if (window.__rfCardInit) return;
  window.__rfCardInit = true;
  var KEY = 'rf-wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function paint() {
    var list = read();
    document.querySelectorAll('[data-rf-wish]').forEach(function (b) {
      b.classList.toggle('is-active', list.indexOf(b.getAttribute('data-rf-wish')) > -1);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rf-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-rf-wish');
    var list = read();
    var i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); b.classList.remove('is-active'); }
    else { list.push(h); b.classList.add('is-active'); }
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e2) {}
  });
  if (document.readyState !== 'loading') paint();
  else document.addEventListener('DOMContentLoaded', paint);
})();
